export default {
    categories: {
        content:     'Проблемы с контентом',
        improvement: 'Предложения по улучшению',
        other:       'Другой вопрос',
        refill:      'Заявка на пополнение лидов',
        site:        'Нужна помощь по сайту',
        technical:   'Технические проблемы',
    },
    chooseCategory:     'Выберите категорию:',
    commentPlaceholder: 'Напишите комментарий',
    dealerComment:      'Автосалон {name}',
    error:              'Что-то пошло не так, попробуйте еще раз позже',
    success:            'Заявка отправлена',
};
